


















































import { AuthHttp } from "@/mixins/http/auth";
import { Component, Mixins } from "vue-property-decorator";
@Component({})
export default class ForgotPassword extends Mixins(AuthHttp) {
	loading: boolean = false;
	formValid: boolean = false;
	emailAddress: string = "";
	emailRules = [
		(inputText: string) => this.isSet(inputText) || "E-mail is required",
		(inputText: any) => /.+@.+/.test(inputText) || "E-mail must be valid",
	];

	errorMessage: string = "";
	showSuccessMessage: boolean = false;

	attemptRequestPasswordReset(): void {
		this.loading = true;
		this.requestResetPassword(this.emailAddress)
			.then(() => {
				this.showSuccessMessage = true;
				this.errorMessage = "";
			})
			.catch((error: any) => {
				this.showSuccessMessage = false;
				this.errorMessage = error.response.data.message;
			})
			.finally(() => (this.loading = false));
	}

	get canAttemptRequestPasswordReset(): boolean {
		return this.formValid;
	}

	private isSet(text: string): boolean {
		return text != undefined && text != null && text != "";
	}
}
